import React from 'react';
import camelcase from 'camelcase-es5';

import Box, { TBoxProps } from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TitleKind, TTitle } from './types';

type TTitleBaseProps = {
  as: TBoxProps['as'];
  kind: TitleKind;
} & TTitle;

const TitleBase = ({ as, kind, color = '', ...rest }: TTitleBaseProps) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind && camelcase(kind),
    utilities: color && camelcase(`color-${color}`),
  });
  return <Box {...rest} {...conditionalProps} as={as} name="Title" />;
};

export default React.memo(TitleBase);
